<template>
  <v-container
    fluid
    fill-height
    class="pt-2 grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout>
      <fixed-fee v-if="SelectedFunder.fixed_fee > 0"></fixed-fee>
      <fee-tiers v-else-if="SelectedFunder.fee_tiers.length > 1"></fee-tiers>
      <percentage-fee v-else-if="SelectedFunder.fee_tiers.length > 0"></percentage-fee>
      <new-fee-tier v-else></new-fee-tier>
      <b-b-b-product-term></b-b-b-product-term>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import FeeTiers from './FeeTiers';
import FixedFee from './FixedFee';
import PercentageFee from './PercentageFee';
import NewFeeTier from './NewFeeTier';
import BBBProductTerm from './BBBProductTerm';

export default {
  components: {
    FeeTiers,
    FixedFee,
    PercentageFee,
    NewFeeTier,
    BBBProductTerm
  },
  name: 'fees',
  computed: {
    ...mapGetters(['SelectedFunder'])
  },
  methods: {}
};
</script>

<style scoped></style>
